var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_vm._v(" Forma de pagamento "),_c('br'),_vm._v(" Valor total: "+_vm._s(_vm.productsTotal)+" "),_c('div',{ref:"paypal"})])}
var staticRenderFns = []

export { render, staticRenderFns }